import {
  useGetTourQuery,
  useUpdateTourDetailsMutation,
} from '@carboncopyco/data';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { usePermissionsContext } from '../../utils';
import { InfoPageEditableTitle } from '../InfoPageEditableTitle';
import { useTourPageProps } from './TourPageContext';

export const TourPageTitle = () => {
  const { organizationId, tourId, workspaceId, readOnly } = useTourPageProps();
  const { data: tour } = useGetTourQuery({
    organizationId,
    workspaceId,
    id: tourId,
  });
  const [updateTour] = useUpdateTourDetailsMutation();
  const { getPermissions } = usePermissionsContext();
  const updateTourPermission = getPermissions(
    PermissionKey.tour,
    PermissionAction.updateTourById
  );
  return (
    <InfoPageEditableTitle
      title={tour?.tourName}
      onTitleChange={(newTourName) =>
        newTourName
          ? updateTour({
              organizationId,
              id: tourId,
              tourName: newTourName,
            })
          : undefined
      }
      disabled={readOnly || !updateTourPermission}
    />
  );
};
